import React, { PureComponent } from 'react'
import { Grid, Typography, Table, TableHead, TableRow, TableCell, Paper, TableBody, TextField } from '@material-ui/core'

import { CreateUserForm, UserOptions } from './components'

import { LINE_IDs } from 'constants/arrays'

const roles = {
  limitedDispatcher: 'Обмежений диспетчер',
  alimanDispatcher: 'Аліман диспетчер',
  dispatcher: 'Диспетчер',
  developer: 'Програміст',
  carrier: 'Перевізник',
  partner: 'Партнер',
  driver: 'Водій',
  admin: 'Адмін',
}

export class UsersBase extends PureComponent {
  componentDidMount() {
    const { getUsers } = this.props

    getUsers()
  }

  onOptionClick = ({ type, data: { email, uid } }) => {
    const { resetUserPassword, showModal, deleteUser } = this.props

    /* eslint-disable */
    switch (type) {
      case 'reset':
        resetUserPassword(email)
        break
      case 'history':
        showModal({ type: 'userHistory', data: { uid } })
        break
      case 'delete':
        deleteUser({ uid })
        break
      default:
        return
    }
    /* eslint-enable */
  }

  onLineIdChange = uid => e => {
    this.props.setUserLineId({ uid, lineId: e.target.value })
  }

  renderUser = ({ id, email, name, role, lineId }) => (
    <TableRow key={id}>
      <TableCell padding='checkbox'>
        <UserOptions
          uid={id}
          email={email}
          onOptionClick={this.onOptionClick}
        />
      </TableCell>

      <TableCell>{email}</TableCell>
      <TableCell>{name}</TableCell>
      <TableCell>{roles[role]}</TableCell>
      {this.props.isPrexBus && (
        <TableCell>
          <TextField
            select
            name='lineId'
            value={lineId || ''}
            onChange={this.onLineIdChange(id)}
            InputProps={{
              style: { fontSize: 'inherit' }
            }}
            SelectProps={{
              native: true
            }}
          >
            <option value='' />
            {LINE_IDs.map(lineId => (
              <option key={lineId} value={lineId}>
                {lineId}
              </option>
            ))}
          </TextField>
        </TableCell>
      )}
    </TableRow>
  )

  render() {
    const { classes, users, isPrexBus } = this.props

    return (
      <Grid
        container
        spacing={32}
        direction='column'
        component='section'
        className={classes.container}
      >
        <Grid item xs>
          <Typography
            gutterBottom
            variant='h6'
          >
            Добавити користувача
          </Typography>
          <CreateUserForm />
        </Grid>
        <Grid item xs>
          <Typography
            gutterBottom
            variant='h6'
          >
            Користувачі
          </Typography>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding='checkbox' />
                  <TableCell>Email</TableCell>
                  <TableCell>Імя</TableCell>
                  <TableCell>Роль</TableCell>
                  {isPrexBus && (
                    <TableCell>Лінія</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map(this.renderUser)}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Users.js